import { ReactComponent as ApprovIcon } from '../assets/icons/approv.svg';
import { ReactComponent as ApprovNoticeIcon } from '../assets/icons/approv_notice.svg';
import { ReactComponent as DisapprovIcon } from '../assets/icons/disapprov.svg';
import { ReactComponent as ExpiredIcon } from '../assets/icons/expired.svg';
import { ReactComponent as HiddenIcon } from '../assets/icons/hidden.svg';
import { ReactComponent as MonthlyExpirationIcon } from '../assets/icons/monthly_expiration.svg';
import { ReactComponent as NearExpirationIcon } from '../assets/icons/near_expiration.svg';
import { ReactComponent as NotUploadedIcon } from '../assets/icons/not_uploaded.svg';
import { ReactComponent as PendingIcon } from '../assets/icons/pending.svg';
import { IDocument } from './document';

export enum statuses {
  'APPROV' = 'APPROV',
  'APPROV_NOTICE' = 'APPROV_NOTICE',
  'DISAPPROV' = 'DISAPPROV',
  'PENDING' = 'PENDING',
  'EXPIRED' = 'EXPIRED',
}

export const statusFilters = [
  {
    statuses: [statuses.APPROV],
    label: 'Aprovado',
    icon: ApprovIcon,
  },

  {
    statuses: [statuses.DISAPPROV],
    label: 'Reprovado',
    icon: DisapprovIcon
  },

  {
    statuses: [statuses.EXPIRED],
    label: 'Vencido',
    icon: ExpiredIcon
  },
  {
    statuses: ['NOT_UPLOADED' as statuses],
    label: 'Não Inserido',
    icon: NotUploadedIcon
  },
  {
    statuses: ['MONTHLY_EXPIRATION' as statuses],
    label: 'Vencimento no mês',
    icon: MonthlyExpirationIcon
  },
  {
    statuses: ['NEAR_EXPIRATION' as statuses],
    label: 'À vencer (60 dias)',
    icon: NearExpirationIcon
  },
  {
    statuses: [statuses.APPROV_NOTICE],
    label: 'Aprovado com ressalva',
    icon: ApprovNoticeIcon,
  },
  {
    statuses: [statuses.PENDING],
    label: 'Pendente',
    icon: PendingIcon
  },
  {
    statuses: ['HIDDEN' as statuses],
    label: 'Descontinuado',
    icon: HiddenIcon
  }
];

export const getStatusLabel = (status: string, multiples: boolean = false, invalid: boolean = false) => {
  switch (status) {
  case 'APPROV':
    return multiples ? 'Aprovados' : 'Aprovado';
  case 'APPROV_NOTICE':
    return multiples ? 'Aprovados com ressalva' : 'Aprovado com ressalva';
  case 'DISAPPROV':
    const pre = multiples ? 'Reprovados' : 'Reprovado';
    const pos = invalid ? ' (Inválido)' : '';
    return `${pre}${pos}`;
  case 'EXPIRED':
    return multiples ? 'Vencidos' : 'Vencido';
  case 'NOT_UPLOADED':
    return multiples ? 'Não inseridos' : 'Não inserido';
  case 'PENDING':
  default:
    return multiples ? 'Pendentes' : 'Pendente';
  }
};

export interface IFile {
  id?: number;
  // Nome do arquivo. Por padrão será gerado um nome aleatório. Poderá ser editado pelo auditor.
  filename: string;

  // arquivo em base64
  file?: string;

  url: string;

  // Data de emissão do documento. Por padrão ficará vazio. Será definida pelo auditor.
  emissionDate: Date;

  // Data de vencimento do documento. Por padrão ficará vazio. Será definida pelo auditor.
  expirationDate: Date;

  expirationTime?: Date;

  // Tempo de vencimento. Tempo que falta para o documento vencer.
  // @virtual: Campo calculado pelo sistema: Data de vencimento - Data de emissão
  // expirationTime: Date;

  // Período de validade do arquivo. Buscar o parâmetro que está no cadastro do documento.
  frequency: string;

  // Situação do arquivo
  status: statuses;

  // Data de upload do arquivo. Data em que o upload do arquivo ocorreu.
  uploadDate: Date;

  // Data de validação do arquivo. Data em que a validação do arquivo ocorreu.
  validationDate: Date;

  // Criticidade do arquivo. Buscar o parâmetro que está no cadastro do documento.
  criticality: string;

  documentId: number;
  creatorId: number;

  // Datas padrão do banco
  createdDate: Date;
  updatedDate: Date;

  document?: IDocument;
  invalid?: boolean;

  notice: string;
}
